import { ICountryHealth, IHealthSummary, ISelectOption } from './types';

export const HEALTH_SUMMARY: IHealthSummary = {
  netExposureLabel: '-12.5M kWh',
  awaitingConfirmations: 40,
  mismatch: 28,
};

export const COUNTRY_HEALTH_DATA: ICountryHealth[] = [
  {
    id: 'ES',
    name: 'Spain',
    flagCode: 'Es',
    netValueLabel: '-14.494M',
    trend: 'down',
    mismatch: 0,
    pending: 18,
    matched: 8,
    favorite: false,
    marketId: 11,
  },
  {
    id: 'FR',
    name: 'France',
    flagCode: 'Fr',
    netValueLabel: '35.587M',
    trend: 'up',
    mismatch: 4,
    pending: 0,
    matched: 2,
    favorite: false,
    marketId: 5,
  },
  {
    id: 'IT',
    name: 'Italy',
    flagCode: 'It',
    netValueLabel: '-101.50',
    trend: 'down',
    mismatch: 4,
    pending: 18,
    matched: 0,
    favorite: false,
    marketId: 7,
  },
  {
    id: 'NL',
    name: 'Netherlands',
    flagCode: 'Nl',
    netValueLabel: '-182.50M',
    trend: 'down',
    mismatch: 0,
    pending: 18,
    matched: 0,
    favorite: false,
    marketId: 8,
  },
  {
    id: 'DE',
    name: 'Germany',
    flagCode: 'De',
    netValueLabel: '-178.75M',
    trend: 'down',
    mismatch: 4,
    pending: 0,
    matched: 8,
    favorite: false,
    marketId: 12,
  },
  {
    id: 'DK',
    name: 'Denmark',
    flagCode: 'Dk',
    netValueLabel: '-33.538M',
    trend: 'down',
    mismatch: 0,
    pending: 0,
    matched: 8,
    favorite: false,
    marketId: 4,
  },
  {
    id: 'BE',
    name: 'Belgium',
    flagCode: 'Be',
    netValueLabel: '-35.760M',
    trend: 'down',
    mismatch: 4,
    pending: 18,
    matched: 0,
    favorite: false,
    marketId: 2,
  },
  {
    id: 'AT',
    name: 'Austria',
    flagCode: 'At',
    netValueLabel: '-92.64M',
    trend: 'down',
    mismatch: 4,
    pending: 0,
    matched: 0,
    favorite: false,
    marketId: 1,
  },
  {
    id: 'SK',
    name: 'Slovakia',
    flagCode: 'Sk',
    netValueLabel: '-99.3M',
    trend: 'down',
    mismatch: 0,
    pending: 18,
    matched: 8,
    favorite: false,
    marketId: 10,
  },
  {
    id: 'HU',
    name: 'Hungary',
    flagCode: 'Hu',
    netValueLabel: '-30.36M',
    trend: 'down',
    mismatch: 4,
    pending: 0,
    matched: 0,
    favorite: false,
    marketId: 6,
  },
];

export const MARKET_OPTIONS: ISelectOption[] = [
  { value: 'all', label: 'All Markets' },
  ...COUNTRY_HEALTH_DATA.map((country) => ({
    value: country.id,
    label: country.name,
  })),
];

export const MATCHING_STATUS_OPTIONS: ISelectOption[] = [
  { value: 'all', label: 'All' },
  { value: 'mismatch', label: 'Mismatch' },
  { value: 'pending', label: 'Pending' },
  { value: 'matched', label: 'Matched' },
];

export const UNIT_LABEL = 'kWh';
